import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=40204972&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=40204972&prod&scoped=true&lang=css"
import style1 from "@/assets/css/shared-styles/editBox.css?vue&type=style&index=1&id=40204972&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40204972",
  null
  
)

export default component.exports